// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tg-0";
export var checkoutRateBadgeLink = "_tg-1";